export default __webpack_public_path__ + "static/media/POPPINS-EXTRABOLD.82766557.TTF";